import { useContext, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { AppContext, UseChangeWebPageTitle } from '../../../common';
import { ACTIONS } from '../../../constants';
import { getActionService } from '../../../utils/getActionService';
import { DesktopCalendar } from '../components/desktop-calendar/DesktopCalendar';
import { CalendarController } from '../components/desktop-calendar/controllers';
import { MobileCalendar } from '../components/mobile-calendar';
import { DataInfoExtendedProps } from '../components/modals/DetailsModal';
import { HistoryModal } from '../components/modals/HistoryModal';
import { PendingModal } from '../components/modals/PendingModal';
import { RequestModal } from '../components/modals/RequestModal';
import { OvertimesTable } from '../components/overtimes/components/OvertimesTable';
import { EventsTable } from '../components/events/components/EventsTable';
import '../styles/style.css'

export interface TProps {
    startDate: string;
    endDate: string;
    startHour: string;
    endHour: string;
    type: string;
    info?: DataInfoExtendedProps;
    isDateLocked?: boolean;
}

export const HomeEmployeesPortal = () => {
    const { activeSkinConfig, userInfo } = useContext(AppContext);

    let currentDate = new Date();

    const [date, setDate] = useState(currentDate);
    const [isOpenRequestModal, setisOpenRequestModal] = useState(false);
    const [isOpenHistoryModal, setisOpenHistoryModal] = useState(false);
    const [isOpenPendingModal, setIsOpenPendingModal] = useState(false);
    const [requestModalInfo, setRequestModalInfo] = useState<TProps>();
    const [selectedOption, setSelectedOption] = useState("Calendar")

    // Codigo para tomar los rangos de fechas del calendario
    const { schedulings, hanlderReloading, isLoading } = CalendarController(date);

    const { nameOfWebPage } = UseChangeWebPageTitle('Portal de empleados');

    const handlerCreateRequestFromButton = (
        type: string,
        startDate: string,
        endDate: string,
        startHour: string,
        endHour: string,
        info?: DataInfoExtendedProps
    ) => {
        setisOpenRequestModal(true);
        setRequestModalInfo({
            type,
            startDate,
            endDate,
            startHour,
            endHour,
            info,
            isDateLocked: true,
        });
    };

    // Función para cambiar al mes anterior
    const prevMonth = () => {
        const newDate = new Date(date);
        newDate.setMonth(date.getMonth() + 1, 1); // Restamos un mes sin perder la precisión de los días
        setDate(newDate);
    };

    // Función para cambiar al mes siguiente
    const nextMonth = () => {
        const newDate = new Date(date);
        newDate.setMonth(date.getMonth() - 1, 1); // Sumamos un mes sin perder la precisión de los días
        setDate(newDate);
    };

    const showManageRequests = () => {
        return (
            getActionService(userInfo.actions, ACTIONS['approved.scheduling']) ||
            getActionService(userInfo.actions, ACTIONS['approve.interruptions']) ||
            getActionService(userInfo.actions, ACTIONS['approve.covers'])
        );
    };

    const renderMainContent = () => {
        switch (selectedOption.toLowerCase()) {
            case 'calendar':
                return isDesktop ? (
                    <DesktopCalendar
                        schedulings={schedulings}
                        prevMonth={prevMonth}
                        nextMonth={nextMonth}
                        currentDate={date}
                        handlerCreateRequestFromButton={handlerCreateRequestFromButton}
                    />
                ) : (
                    <MobileCalendar
                        schedulings={schedulings}
                        handlerCreateRequestFromButton={handlerCreateRequestFromButton}
                        nextMonth={nextMonth}
                        prevMonth={prevMonth}
                        currentDate={date}
                    />
                );

            case 'overtimes':
                return <OvertimesTable />

            case 'events':
                return <EventsTable />;
            
            default:
                return null;
        }
    };

    const visualizerControls = () => {
        return (
            <>
                {selectedOption === 'overtimes' ? (
                    <button
                        onClick={() => setSelectedOption('calendar')}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Volver</h5>
                        <i className='ri-arrow-left-circle-line fs-5 m-0 p-0 text-primary2'></i>
                    </button>
                ) : (
                    <button
                        onClick={() => setSelectedOption('overtimes')}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Extras y Recargos</h5>
                        <i className='ri-chat-history-line fs-5 m-0 p-0 text-primary2'></i>
                    </button>
                )}
                

                {selectedOption === 'events' ? (
                    <button
                        onClick={() => setSelectedOption('calendar')}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Volver</h5>
                        <i className='ri-arrow-left-circle-line fs-5 m-0 p-0 text-primary2'></i>
                    </button>
                ) : (
                    <button
                        onClick={() => setSelectedOption('events')}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Ver marcaciones</h5>
                        <i className='ri-booklet-line fs-5 m-0 p-0 text-primary2'></i>
                    </button>
                )}

                {showManageRequests() && (
                    <button
                        onClick={() => {
                            const today = new Date().toLocaleDateString('en-CA');

                            setRequestModalInfo({
                                type: '',
                                startDate: today,
                                endDate: today,
                                startHour: '',
                                endHour: '',
                                isDateLocked: false,
                            });

                            setisOpenRequestModal(true);

                            const offcanvasElement = document.getElementById('menuActions');
                            if (offcanvasElement) {
                                const offcanvas = (window as any).bootstrap?.Offcanvas?.getInstance(offcanvasElement);
                                if (offcanvas) offcanvas.hide();
                            }
                        }}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Cambios</h5>
                        <svg width='20' height='20' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                                fill-rule='evenodd'
                                clip-rule='evenodd'
                                d='M16 6.66667C14.2319 6.66667 12.5362 7.36905 11.286 8.61929C10.0357 9.86953 9.33333 11.5652 9.33333 13.3333V16C9.33333 16.7364 8.73638 17.3333 8 17.3333C7.26362 17.3333 6.66667 16.7364 6.66667 16V13.3333C6.66667 10.858 7.65 8.48401 9.40034 6.73367C11.1507 4.98333 13.5246 4 16 4C18.4754 4 20.8493 4.98333 22.5997 6.73367C24.223 8.35705 25.1866 10.5169 25.3179 12.7965L27.0572 11.0572C27.5779 10.5365 28.4221 10.5365 28.9428 11.0572C29.4635 11.5779 29.4635 12.4221 28.9428 12.9428L24.9428 16.9428C24.4221 17.4635 23.5779 17.4635 23.0572 16.9428L19.0572 12.9428C18.5365 12.4221 18.5365 11.5779 19.0572 11.0572C19.5779 10.5365 20.4221 10.5365 20.9428 11.0572L22.6416 12.756C22.5064 11.1995 21.8275 9.73273 20.714 8.61929C19.4638 7.36905 17.7681 6.66667 16 6.66667ZM5.17157 21.1716C5.92172 20.4214 6.93913 20 8 20C9.06087 20 10.0783 20.4214 10.8284 21.1716C11.5786 21.9217 12 22.9391 12 24C12 25.0609 11.5786 26.0783 10.8284 26.8284C10.0783 27.5786 9.06087 28 8 28C6.93913 28 5.92172 27.5786 5.17157 26.8284C4.42143 26.0783 4 25.0609 4 24C4 22.9391 4.42143 21.9217 5.17157 21.1716ZM8 22.6667C7.64638 22.6667 7.30724 22.8071 7.05719 23.0572C6.80714 23.3072 6.66667 23.6464 6.66667 24C6.66667 24.3536 6.80714 24.6928 7.05719 24.9428C7.30724 25.1929 7.64638 25.3333 8 25.3333C8.35362 25.3333 8.69276 25.1929 8.94281 24.9428C9.19286 24.6928 9.33333 24.3536 9.33333 24C9.33333 23.6464 9.19286 23.3072 8.94281 23.0572C8.69276 22.8071 8.35362 22.6667 8 22.6667ZM21.1716 21.1716C21.9217 20.4214 22.9391 20 24 20C25.0609 20 26.0783 20.4214 26.8284 21.1716C27.5786 21.9217 28 22.9391 28 24C28 25.0609 27.5786 26.0783 26.8284 26.8284C26.0783 27.5786 25.0609 28 24 28C22.9391 28 21.9217 27.5786 21.1716 26.8284C20.4214 26.0783 20 25.0609 20 24C20 22.9391 20.4214 21.9217 21.1716 21.1716ZM24 22.6667C23.6464 22.6667 23.3072 22.8071 23.0572 23.0572C22.8071 23.3072 22.6667 23.6464 22.6667 24C22.6667 24.3536 22.8071 24.6928 23.0572 24.9428C23.3072 25.1929 23.6464 25.3333 24 25.3333C24.3536 25.3333 24.6928 25.1929 24.9428 24.9428C25.1929 24.6928 25.3333 24.3536 25.3333 24C25.3333 23.6464 25.1929 23.3072 24.9428 23.0572C24.6928 22.8071 24.3536 22.6667 24 22.6667Z'
                                fill={activeSkinConfig.principalColor}
                            />
                        </svg>   
                    </button>
                )}

                <button
                    onClick={() => setisOpenHistoryModal(!isOpenHistoryModal)}
                    className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                >
                    <h5 className='m-0 p-0 text-primary2'>Historial</h5>
                    <i className='ri-time-line fs-5 m-0 p-0 text-primary2'></i>
                </button>

                {showManageRequests() && (
                    <button
                        onClick={() => setIsOpenPendingModal(!isOpenPendingModal)}
                        className='rounded btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                    >
                        <h5 className='m-0 p-0 text-primary2'>Solicitudes</h5>
                        <i className='ri-clipboard-line fs-5 m-0 p-0 text-primary2'></i>
                    </button>
                )}
            </>
        );
    };

    return (
        <div className='visualizer mt-5 py-4' id="mainVisualizerPanel">
            <div className='visualizer__wrapper p-2 py-0'>
                {isDesktop ? (
                    <div className='visualizer__controls  d-flex justify-content-between gap-2  justify-content-md-end '>
                        {visualizerControls()}        
                    </div>
                ): (
                    <>
                        <div className='visualizer__wrapper p-2 py-0'>
                            <button                                     
                                className='rounded  btn btn-withe text-primary2 fw-bold d-flex justify-content-center align-items-center gap-2'
                                data-bs-toggle="offcanvas" data-bs-target="#menuActions">
                                <i className="ri-more-2-fill fs-4 text-primary2"></i>
                                <h5 className='m-0 p-0 text-primary2'>Opciones</h5>
                            </button>
                        </div>
                        <div className="offcanvas offcanvas-end" id="menuActions" >
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title">Opciones</h5>
                            </div>
                            <div className="offcanvas-body d-flex flex-column gap-3 px-3 py-3">
                                {visualizerControls()}
                            </div>
                        </div>
                        <br></br>
                    </>
                )}
                
                {renderMainContent()}

                {isOpenPendingModal && showManageRequests() && (
                    <PendingModal
                        isOpen={isOpenPendingModal}
                        onClose={setIsOpenPendingModal}
                    />
                )}

                {isOpenHistoryModal && (
                    <HistoryModal
                        date={date}
                        isOpen={isOpenHistoryModal}
                        onClose={setisOpenHistoryModal}
                    />
                )}

                {isOpenRequestModal && showManageRequests() && (
                    <RequestModal
                        requestModalInfo={requestModalInfo}
                        isOpen={isOpenRequestModal}
                        onClose={setisOpenRequestModal}
                    />
                )}
            </div>
        </div>
    );
};